export default __webpack_public_path__ + "static/media/computer.f9716a65.png";